export const GLOBAL_ERROR = 'GLOBAL_ERROR';
export const RESET_GLOBAL_ERROR = 'RESET_GLOBAL_ERROR';

const sanitize = (err) => {
  if (err.status) {
    return {
      ...err,
      status: err.status.toString(),
    };
  }
  return err;
};

export const globalError = (err) => ({
  type: GLOBAL_ERROR,
  payload: sanitize(err),
});

export const reset = () => ({
  type: RESET_GLOBAL_ERROR,
});

export const handleError = (dispatch, error, fallback) => {
  if (error.type === GLOBAL_ERROR) {
    dispatch(error);
  }
  dispatch(fallback);
};
